<template>
  <ModalComponent />
  <SidebarComponent />
  <WallComponent />
</template>

<script>
import ModalComponent from './modals/ModalComponent.vue'
import WallComponent from './WallComponent.vue'
import SidebarComponent from './SidebarComponent.vue'

export default {
  name: 'RootComponent',
  components: {
    ModalComponent,
    WallComponent,
    SidebarComponent,
  },
}
</script>

<style scoped>
</style>
